import { Controller } from "@hotwired/stimulus"

// Places the text cursor at the end of a focused input's value when it connects.
// Useful for rename/edit modals where the field is pre-filled and we don't want
// the cursor to land at position 0.
export default class extends Controller {
  connect() {
    const el = this.element
    const end = el.value.length

    // Ensure focus first (in case autofocus hasn't kicked in yet).
    el.focus()
    el.setSelectionRange(end, end)
  }
}
